import { Component, OnDestroy, OnInit } from '@angular/core';
import { SecurityPermissionName } from '@app/core/models/permission';
import { SiteContextService } from '@app/shared/services/context/site-context.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'portal-enterprise-site-sub-nav',
  templateUrl: './enterprise-site-sub-nav.component.html',
  styles: [],
  standalone: false,
})
export class EnterpriseSiteSubNavComponent implements OnDestroy, OnInit {
  site$ = this.siteContextService.siteWithLocations.data$.pipe(
    untilDestroyed(this),
    map((siteWithLocations) => siteWithLocations.site)
  );
  siteName$ = this.site$.pipe(map((s) => s.name));
  Permission = SecurityPermissionName;

  loading = true;

  constructor(private siteContextService: SiteContextService) {}

  ngOnDestroy(): void {}

  ngOnInit() {
    this.siteContextService.siteWithLocations.loading$
      .pipe(untilDestroyed(this))
      .subscribe((loading) => (this.loading = loading));
  }
}
